import { Quill } from 'react-quill';
const BlockEmbed = Quill.import('blots/block/embed');
export class ImageBlot extends BlockEmbed {
  static get ATTRIBUTES() { return ['src', 'alt', 'height', 'width', 'class', 'style'] }
  static blotName = "image";
  static tagName = "IMG";
  static allowedChildren = ["img"];

  static create(domEl: HTMLElement | string) {
    let node = super.create();
    if (typeof domEl === 'string') {
      node.setAttribute('src', domEl)
    } else {
      for (let i = 0; i < domEl.attributes.length; i++) {
        const { name } = domEl.attributes[i];
        if (ImageBlot.ATTRIBUTES.indexOf(name) > -1) {
          const value = domEl.getAttribute(name);
          if (value) {
            node.setAttribute(name, value);
          } else {
            node.removeAttribute(name);
          }
        }
      }
    }
    return node;
  }
  static value(node: HTMLElement) {
    return node;
  }
  static formats(domNode: any) {
    return ImageBlot.ATTRIBUTES.reduce(function (formats: any, attribute) {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
      return formats;
    }, {});
  }
  format(name: string, value: string) {
    if (ImageBlot.ATTRIBUTES.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }
}